



















































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { errorHandling } from '@/helpers/errorHandling';
import IDoctor from '@/interfaces/doctor';
import TeamModel from '@/models/team-model';
import * as doctorService from '@/services/doctors';
import { getHealthInsurance } from '@/services/prescription';
import * as service from '@/services/teams';
import {
  ERROR_CODE_DUPLICATE,
  ERROR_CODE_TEAM_DUPLICATE_CODE
} from '@/settings/consts/api-error';
import {
  MESSAGE_TEAM_DOCTOR_DUPLICATE,
  MESSAGE_TEAM_ERROR
} from '@/settings/consts/messages';
import { cloneDeep } from 'lodash';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    UiSelectDoctor,
    UiSelectClients,
    UiAutocompleClientsSubsidiaries,
  },
})
export default class TeamForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public editItem: any;

  public doctors: IDoctor[] = [];
  public doctorLoading: boolean = false;
  public disabled: boolean = true;

  public form: any = {
    valid: false,
    rules: {
      codigo: [(v) => !!v || 'Digite o código'],
      name: [(v) => !!v || 'Digite o nome'],
      client: [(v) => (!!v && !!v.id) || 'Selecione um cliente'],
      doctors: [(v) => this.isDoctorsValid() || 'Selecione ao menos 1 médico.'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  isDoctorsValid() {
    return (!this.item.ativo || (this.item.medicos && this.item.medicos.length > 0)) ;
  }

  public item: TeamModel = new TeamModel();
  public healthInsurance: any[] = [];

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = new TeamModel(val);
    setTimeout(() => {
      this.onClientChange();
    }, 500);
  }

  public beforeMount() {
    this.getHealthInsurance();
  }

  public onClientChange() {    
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando registro...');

    const onError = (error) => {
      this.loader.stop();
      const defaultMessage =
        !!error.data && !!error.data.message
          ? error.data.message
          : MESSAGE_TEAM_ERROR;
      const errorMessages = {
        default: MESSAGE_TEAM_ERROR,
        [ERROR_CODE_DUPLICATE]: `${MESSAGE_TEAM_DOCTOR_DUPLICATE} ${error.data.message}`,
        [ERROR_CODE_TEAM_DUPLICATE_CODE]: defaultMessage,
      };

      const message = errorHandling(error, errorMessages);

      this.toast.show(message, 'error');
    };

    if (!this.item.id) {
      service.saveTeam(this.item.toTimeParmDTO()).subscribe((data) => {
        this.loader.stop();
        this.$emit('save', new TeamModel(data));
        this.$refs.form.resetValidation();
      }, onError);
    } else {
      service.updateTeam(this.item.toTimeParmDTO()).subscribe((data) => {
        this.loader.stop();
        this.$emit('save');
        this.$refs.form.resetValidation();
      }, onError);
    }
  }

  public closeForm(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }


  private getHealthInsurance(): void {
    getHealthInsurance().subscribe((data) => {
      this.healthInsurance = data;
    });
  }

  @Watch("item.ativo")
  private onStatusChange() {
    this.$refs.form.validate();
  }
}
